/**
 * <strong>Purpose:</strong> <br>
 * Adds aria-labelledBy attribute to the widget.
 * <br><br>
 * <strong>Contract:</strong> <br>
 * The widget should have focusNode and textNode. <br>
 * This mixin is dependent upon: <br>
 * {@link module:mw-form/mixins/property/TextMixin} <br>
 *
 * @module mw-form/mixins/AriaLabelledByMixin
 *
 * @copyright Copyright 2018 The MathWorks, Inc.
 */

define([
    "dojo/_base/declare",
    "mw-form/mixins/property/TextMixin"
], function (declare, TextMixin) {

    var AriaLabelledByMixin = declare(null, {

        postCreate: function () {
            this.inherited(arguments);

            var ariaLabel = this.id + "_label";
            this.focusNode.setAttribute("aria-labelledby", ariaLabel);
            this.textNode.setAttribute("id", ariaLabel);
        }
    });

    AriaLabelledByMixin._dependencies = [
        {mixin: TextMixin, orderDependent: false}
    ];
    return AriaLabelledByMixin;
});
